import PropTypes from 'prop-types';

import styles from './RequiredFieldsLayout.module.scss';

const RequiredFieldsLayout = ({ children }) => (
  <section className={styles.requiredFieldsLayout}>{children}</section>
);

RequiredFieldsLayout.propTypes = {
  children: PropTypes.node,
};

RequiredFieldsLayout.defaultProps = {
  children: <div />,
};

export default RequiredFieldsLayout;
